import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import { FiPhone, FiMapPin, FiClock } from 'react-icons/fi';
import { FaInstagram, FaFacebook } from 'react-icons/fa';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    from_name: '',
    from_email: '',
    phone: '',
    postal_code: '',
    city: '',
    message: '',
    service_type: ''
  });
  const [status, setStatus] = useState('');

  const serviceTypes = [
    'Devis général',
    'Tonte de pelouse',
    'Taille des haies',
    'Désherbage',
    'Ramassage des feuilles',
    'Débroussaillage',
    'Petit élagage'
  ];

  const handleChange = (e) => {
    let value = e.target.value;
    
    // Formatage spécial pour le champ téléphone
    if (e.target.name === 'phone') {
      // Supprimer tous les caractères non numériques
      value = value.replace(/\D/g, '');
      // Limiter à 10 chiffres
      value = value.slice(0, 10);
      // Ajouter les espaces : 06 00 00 00 00
      if (value.length >= 2) {
        value = value.replace(/(\d{2})(\d{2})?(\d{2})?(\d{2})?(\d{2})?/, (match, p1, p2, p3, p4, p5) => {
          let formatted = p1;
          if (p2) formatted += ' ' + p2;
          if (p3) formatted += ' ' + p3;
          if (p4) formatted += ' ' + p4;
          if (p5) formatted += ' ' + p5;
          return formatted;
        });
      }
    }

    if (e.target.name === 'postal_code') {
      value = value.replace(/\D/g, '').slice(0, 5);
    }
    
    setFormData({
      ...formData,
      [e.target.name]: value
    });
  };

  const sendEmail = (e) => {
    e.preventDefault();
    setStatus('sending');

    const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
    const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
    const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

    emailjs.send(
      SERVICE_ID,
      TEMPLATE_ID,
      formData,
      PUBLIC_KEY
    ).then(() => {
      setStatus('success');
      setFormData({
        from_name: '',
        from_email: '',
        phone: '',
        postal_code: '',
        city: '',
        message: '',
        service_type: ''
      });
      setTimeout(() => setStatus(''), 5000);
    }).catch((error) => {
      console.error('EmailJS error:', error);
      setStatus('error');
      setTimeout(() => setStatus(''), 5000);
    });
  };

  return (
    <section id="contact" className="contact">
      <div className="contact-container">
        <div className="contact-header">
          <h2>Contactez-nous</h2>
          <p>Demandez votre devis gratuit ou posez-nous vos questions</p>
        </div>

        <div className="contact-content">
          <div className="contact-info">
            <h3>Informations pratiques</h3>
            
            <div className="contact-item">
              <FiPhone className="contact-icon" />
              <div>
                <h4>Téléphone</h4>
                <a href="tel:+33780643074">07 80 64 30 74</a>
              </div>
            </div>


            <div className="contact-item">
              <FiMapPin className="contact-icon" />
              <div>
                <h4>Zone d'intervention</h4>
                <p>Secteur de Villemur-sur-Tarn 31340 et environs<br />Rayon de 45km</p>
              </div>
            </div>

            <div className="contact-item">
              <FiClock className="contact-icon" />
              <div>
                <h4>Horaires</h4>
                <p>Lundi - Vendredi : 8h - 18h<br />Samedi : 8h - 12h</p>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-social">
                <a href="https://www.instagram.com/pochard.ev/" target="_blank" rel="noopener noreferrer" className="contact-social-link">
                  <FaInstagram />
                  <span>Instagram</span>
                </a>
                <a href="https://www.facebook.com/jordan.pochard.900" target="_blank" rel="noopener noreferrer" className="contact-social-link">
                  <FaFacebook />
                  <span>Facebook</span>
                </a>
              </div>
            </div>

            <div className="contact-sap">
              <h4>Avantage fiscal</h4>
              <p>Bénéficiez de <strong>-50% de crédit d'impôt</strong> sur tous nos services à domicile</p>
            </div>
          </div>

          <div className="contact-form-wrapper">
            <form className="contact-form" onSubmit={sendEmail}>
              
              <div className="form-group">
                <label htmlFor="from_name">Nom complet *</label>
                <input
                  type="text"
                  id="from_name"
                  name="from_name"
                  value={formData.from_name}
                  onChange={handleChange}
                  required
                  placeholder="Votre nom et prénom"
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="from_email">Email *</label>
                  <input
                    type="email"
                    id="from_email"
                    name="from_email"
                    value={formData.from_email}
                    onChange={handleChange}
                    required
                    placeholder="votre@email.fr"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="phone">Téléphone *</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    placeholder="06 00 00 00 00"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="postal_code">Code postal *</label>
                  <input
                    type="text"
                    id="postal_code"
                    name="postal_code"
                    value={formData.postal_code}
                    onChange={handleChange}
                    required
                    placeholder="31340"
                    inputMode="numeric"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="city">Ville *</label>
                  <input
                    type="text"
                    id="city"
                    name="city"
                    value={formData.city}
                    onChange={handleChange}
                    required
                    placeholder="Villemur-sur-Tarn"
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="service_type">Service demandé</label>
                <select
                  id="service_type"
                  name="service_type"
                  value={formData.service_type}
                  onChange={handleChange}
                >
                  <option value="">Sélectionnez un service</option>
                  {serviceTypes.map((service, index) => (
                    <option key={index} value={service}>{service}</option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="5"
                  placeholder="Décrivez votre demande : superficie, fréquence souhaitée, particularités du terrain..."
                ></textarea>
              </div>

              <button 
                type="submit" 
                className={`submit-btn ${status}`}
                disabled={status === 'sending'}
              >
                {status === 'sending' ? 'Envoi en cours...' : 'Envoyer ma demande'}
              </button>

              {status === 'success' && (
                <div className="form-message success">
                  ✅ Votre message a bien été envoyé ! Nous vous répondrons rapidement.
                </div>
              )}

              {status === 'error' && (
                <div className="form-message error">
                  ❌ Erreur lors de l'envoi. Veuillez réessayer ou nous contacter par téléphone.
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;